import React, { useState } from 'react';
import { LuEye, LuEyeOff } from "react-icons/lu";
import { FaReceipt } from "react-icons/fa6";

const AnimateCard = ({ title, text, text2, buttonview, checkbal, balance }) => {
  const [showAmount, setShowAmount] = useState(false);

  const formattedBalance =
    typeof balance === 'number' ? `₹ ${balance.toFixed(2)}` : "N/A";

  return (
    <div className="w-full group overflow-hidden bg-black rounded-xl bg-gradient-to-tr from-blue-500 via-blue-900 to-blue-700 text-gray-50 relative">
      <div className="relative z-10 w-full h-48 flex flex-col justify-between before:duration-700 before:absolute before:w-28 before:h-28 before:bg-transparent before:blur-none before:border-8 before:opacity-50 before:rounded-full before:-left-4 before:-top-12 group-hover:before:top-28 group-hover:before:left-44 group-hover:before:scale-125 group-hover:before:blur">
        
        <div className="p-4 flex flex-col items-center justify-center">
          <span className="font-bold text-xl mb-1">{title}</span>

          {/* IFSC */}
          <p className="text-sm font-semibold text-center opacity-90">{text2}</p>

          {/* Account Number */}
          <p className="text-lg font-bold mt-1 text-center tracking-wide">{text}</p>

          {/* Toggleable Balance */}
          <div className="flex items-center mt-3 space-x-2">
            <button
              onClick={() => setShowAmount(!showAmount)}
              className="text-white focus:outline-none text-xl"
              title={showAmount ? "Hide Balance" : "Show Balance"}
            >
              {showAmount ? <LuEye /> : <LuEyeOff />}
            </button>
            <span className="text-lg font-semibold">
              {showAmount ? formattedBalance : "••••••"}
            </span>
          </div>
        </div>

        <div className="flex justify-between items-center px-4 pb-3">
          {/* View Statement Button */}
          {buttonview && (
            <div className="flex items-center cursor-pointer border-b font-semibold shadow-md gap-1">
              <FaReceipt />
              <button className="text-sm text-white hover:text-blue-300">
                {buttonview}
              </button>
            </div>
          )}

          {/* Check Balance Button */}
          <div className="flex items-center cursor-pointer border-b font-semibold shadow-md gap-1">
            <LuEyeOff />
            <button className="text-sm text-white hover:text-blue-300">
              {checkbal}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnimateCard;
